import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/globals.css';
import './styles/glassmorphism.css';
import './styles/operationsAesthetics.css';
import registerOfflineServiceWorker from './offline/registerOfflineServiceWorker';
import './finalFixes/productionRuntimeFixes';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
registerOfflineServiceWorker();
import './styles/finalUnifiedDesign.css';




import './styles/basicErpReferenceV44.css';

import './styles/vbwebTheme.css';
